import React, { useEffect, useState } from "react";
import SubscriptionTiles from "../home/subscriptionTiles";
import RecordSection from "../home/record-section";
import MaintenanceRequestSection from "../home/maintainance-request";
import ReceivePayment from "../home/receivePayment";
import TenantsSection from "../home/tenantHome";
import BalancesSection from "../home/balances";
import PropertiesSection from "../home/propertiesHome";
import RenewelSection from "../home/leaseRenewel";
import OccupancyRate from "../home/occupancyRate";
import StatusChart from "../home/stats";
import HeaderSection from "../home/homeHeader";
import TransactionsTable from "../home/transactionsTable";
import OutstandingBalancesTable from "../home/outstandingBalancesTable";
import BaseUrl from "../../../constants/BaseUrl";
import { useSelector } from "react-redux";
const HomeSection = ({
  onNotificationClick,
  onViewDetailsMaintain,
  onViewDetailProperty,
  onMaintainancePage,
  onViewPropertyPage,
  onDetailsTenant,
  onTenantList,
  onLeaseTable,
  onNavigateToPayments,
}) => {
  const { loginSuccess } = useSelector((state) => state.auth);
  const [count, setCount] = useState(0);
  const [showTransactions, setShowTransactions] = useState(false);
  const [showOutstandingBalances, setShowOutstandingBalances] = useState(false);
  useEffect(() => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/notification/getUnreadNotificationCount/${loginSuccess.user._id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          setCount(result.count);
        }
      })
      .catch((error) => console.error(error));
  }, []);

  if (showTransactions) {
    return (
      <TransactionsTable
        onBack={() => setShowTransactions(false)}
        landlordId={loginSuccess?.user?._id}
      />
    );
  }

  if (showOutstandingBalances) {
    return (
      <OutstandingBalancesTable
        onBack={() => setShowOutstandingBalances(false)}
        landlordId={loginSuccess?.user?._id}
      />
    );
  }

  return (
    <div className="w-full mb-8">
      <HeaderSection count={count} onNotificationClick={onNotificationClick} />
      <SubscriptionTiles onNavigateToPayments={onNavigateToPayments} />
      <RecordSection />
      <div className="flex justify-between">
        <div className="w-[50%]">
          <ReceivePayment 
            handleTenantaTable={onTenantList}
            landlordId={loginSuccess?.user?._id}
            onViewAllTransactions={() => {
              setShowTransactions(true);
            }}
          />
          <RenewelSection />
          <MaintenanceRequestSection
            onViewDetails={onViewDetailsMaintain}
            onMaintainanceTable={onMaintainancePage}
          />
          <TenantsSection
            onViewDetails={onDetailsTenant}
            onTenantList={onTenantList}
          />
        </div>
        <div className="w-[49%]">
          <OccupancyRate />
          <StatusChart />
          <BalancesSection handleLeaseTable={() => setShowOutstandingBalances(true)} landlordId={loginSuccess?.user?._id} />
          <PropertiesSection
            onViewDetails={onViewDetailProperty}
            onPropertyPage={onViewPropertyPage}
          />
        </div>
      </div>
    </div>
  );
};

export default HomeSection;
